<template>
<div v-show="isModalVisible">
<div class="modal-mask" @click="closeModal">
      <div class="modal-container" @click.stop>
      <!-- Modal Header -->
      <div class="modal-header">
        <h6 class="modal-title"></h6>
        <button type="button" class="close" data-dismiss="modal" @click="closeModal">&times;</button>
      </div>
      <!-- Modal body -->
      <div class="modal-body">
         <div id="payment_loader">
           <div class="form-group loader-msg" >
             Processing... Please Wait
           </div>
           <div class="form-group row">
             <img src="@/assets/pay-loading.gif"  width="400" height="300" alt="Processing Payment..." class="center">
           </div>
         </div>  
        <div class="form-group row" id="success_payment" style="display: none;">
        <div v-if="status == 'success'">
        <div class="form-group success-msg">
           Order Successful!
        </div>
        <img src="@/assets/green-tick.jpg"  width="100" height="120" alt="Success" class="center">      
        </div>
        
        <div v-else>
             <div class="form-group loader-msg" >
                The transaction is failed. Please check the credit card details entered.
             </div>
        </div>
        </div>
      </div>
     </div>

     

</div>
</div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';

export default {
  props: [
    'isModalVisible',
    'status',
    'orderId',
   ],
  data() {
    return {
        loading: false,
        success_msg: '',      
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
      this.navigate();
    },
    navigate(){
        this.$router.push(this.$router.currentRoute.fullPath)
        this.$router.go();
    }
  },
  
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity .3s ease;
  overflow-y: scroll;
}
.modal-container {
  position: fixed;
  left: 50%;
  top: 50%;
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 500px;
  height: auto;
  overflow-y: auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
.modal-body {
  margin: 0px;
  padding: 10px;
}
.modal-header .sub-heading {
  background-color: #FFF;
  color: #555;
}
.modal-header {
  padding: 5px;
}
.modal-header .close {
  margin: -1.5rem -2rem -1rem auto;
}
.modal-footer {
  border-top: none;
}
.modal-header {
  border-bottom: 0px;
  margin-bottom: 10px;
}
.form-control { font-size: 14px; }
.hide_vmessage {
  display: none !important;
}
.show_vmessage {
  display: block !important;
}
@media (min-width: 320px) and (max-width: 991px) { 
  .modal-container {
    width: 100%;
  }
}
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.success-msg {
  text-align: center;
  font-size: 24px;
  width: 100%;
  color:  #228B22;
}
.loader-msg {
  text-align: center;
  font-size: 24px;
  width: 100%;
  color:  #555;
}

</style>


// WEBPACK FOOTER //
// src/components/admin/enterprise_purchase_confirm.vue